import AuthPane from "components/Home/AuthPane";
import htmlParser from "react-html-parser";
import { NavLink } from "react-router-dom";
import { appStrings } from "utils/appStrings";

export interface ContentProps {
  result?: string;
}

const Content: React.FC<ContentProps> = ({ result }) => {
  return (
    <div className="flex flex-col lg:flex-row container mx-auto p-8">
      <div className="lg:w-11/12 mx-auto">
        <div className="h-full bg-white  text-justify p-8 dark:bg-gray-800 dark:text-white">
          <div className="mx-auto flex flex-wrap justify-between">
            <NavLink
              to="/"
              className="flex flex-row items-center font-semibold text-gray-900 text-lg dark:text-gray-100"
            >
              <img
                src="/assets/img/logo.svg"
                className="w-6 ml-4"
                alt={appStrings.brand}
              />
              {appStrings.brand}
            </NavLink>
            <AuthPane />
          </div>
          <div className="px-4 py-8 leading-loose">
            {htmlParser(result as string)}
          </div>
          <NavLink
            to="/"
            className="flex flex-row items-center justify-center font-semibold text-gray-100 bg-primary-800 w-48 text-center rounded-lg py-2 mx-auto mt-8"
          >
            {appStrings.otherQuizzes}
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Content;
